import React, { Fragment, useContext, useState } from 'react';
import { IoIosArrowRoundDown } from 'react-icons/io';

import { ComponentContext } from '../../../context/componentContext';

import BuyersCard from './BuyersCard';

const FarmWarehouse = () => {
  const { menuOpen } = useContext(ComponentContext);
  const [state, setstate] = useState(false);

  return (
    <Fragment>
      <div className={`flex flex-wrap justify-center ${menuOpen ? 'pl-8 md:pl-24' : ''}`}>
        <div className="w-full md:w-4/5 lg:w-133">
          <div className="bg-cf-300 text-white rounded px-6 py-10 text-center">
            <h4 className="font-semibold">Welcome to your Warehouse!</h4>
            <p className="text-sm md:text-base">
              Here, you can view all the latest updates on your farm produce.
            </p>
          </div>
        </div>
      </div>

      <div
        className={`flex flex-wrap justify-center px-4 md:px-0 mt-10 ${
          menuOpen ? 'pl-8 md:pl-24' : ''
        }`}
      >
        {state ? (
          <>
            <div className="w-full md:w-4/5 lg:w-3/5 mx-auto mt-10">
              <div className="grid grid-cols-1 md:grid-cols-2 md:gap-10 px-4 md:px-0">
                <div className="bg-white rounded p-10 flex flex-col items-center justify-center mb-20 md:mb-0">
                  <h3 className="text-left mb-2">Quantity</h3>
                  <ul>
                    <li className="py-1">
                      <strong>Volume - </strong> Stage 1
                    </li>
                    <li className="py-1">
                      <strong>Weight - </strong> July 21st, 2020
                    </li>
                    <li className="py-1">
                      <strong>Number of bags - </strong> 6 months
                    </li>
                  </ul>
                </div>

                <div className="bg-cf-300 rounded p-10 text-white flex flex-col items-center justify-center">
                  <h3>Quantity</h3>
                  <p className="py-4">Yield conditions - </p>
                  <button className="text-cf-300 bg-white rounded p-4 flex">
                    Download{' '}
                    <span className="rounded-full w-4 h-4">
                      <IoIosArrowRoundDown />
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div className="bg-cf-100 w-full pt-16 pb-32 mt-16 px-4 md:px-0">
              <div className="w-full md:w-4/5 lg:w-3/5 mx-auto mt-10">
                <h5>Suggested buyers </h5>

                <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5 mt-10">
                  <BuyersCard />
                  <BuyersCard />
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="text-center w-full md:w-4/5 lg:w-133 bg-white mb-20 px-6 py-4">
            <h5 className="text-base font-bold">Warehouse Coming Soon</h5>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default FarmWarehouse;
